import React from "react";
import infoCircle from "../../assets/info-circle.svg";
import TagInput from "../TagInput";

const PageSEOFields = ({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
  <div className="theme-card p-4 mb-3">
    <div className="card-title pb-3">SEO</div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        Focus Keywords
        <img className="ms-2" src={infoCircle} alt="Info" title="Add Keywords" />
      </label>
      <div className="tag-card">
        <TagInput
          value={values.focus_keywords}
          onChange={(tags) => setFieldValue("focus_keywords", tags)}
        />
        {touched.focus_keywords && errors.focus_keywords && (
          <div className="input-error">{errors.focus_keywords}</div>
        )}
      </div>
    </div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        SEO Title
        <img className="ms-2" src={infoCircle} alt="Info" title="Add SEO Title" />
      </label>
      <input
        type="text"
        name="metaTitle"
        className="frm-input"
        placeholder="Enter SEO title"
        value={values.metaTitle}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.metaTitle && errors.metaTitle && <div className="input-error">{errors.metaTitle}</div>}
    </div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        Meta Description
        <img className="ms-2" src={infoCircle} alt="Info" title="Add Meta Description" />
      </label>
      <textarea
        name="metaDesc"
        className="frm-input"
        rows={3}
        placeholder="Enter Meta Description"
        value={values.metaDesc}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.metaDesc && errors.metaDesc && (
        <div className="input-error">{errors.metaDesc}</div>
      )}
    </div>
  </div>
);

export default PageSEOFields;
